<template>
  <div class="redelivery_modal_wrapper">
    <BaseModal
      :show="modalAppearanceData"
      @controleModalApperance="controleModalApperance"
    >
      <template #modal>
        <div class="redelivery_card">
          <div class="icon">
            <i class="fal fa-redo"></i>
          </div>

          <h2 class="mb-4">{{ $t("RETURN_REQUESTS.confirmRedelivery") }}</h2>

          <p class="description mb-4">
            {{ $t("RETURN_REQUESTS.redeliveryMessage") }}
          </p>

          <div v-if="errorMessage" class="error_message mb-3">
            <i class="fal fa-exclamation-circle"></i>
            <span>{{ errorMessage }}</span>
          </div>

          <div class="btns_wrapper">
            <button
              class="confirm_btn"
              @click="confirmRedelivery"
              :disabled="isSubmitting"
            >
              <i v-if="isSubmitting" class="fal fa-spinner-third fa-spin"></i>
              <span>{{ $t("BUTTONS.confirm") }}</span>
            </button>

            <button
              class="cancel_btn"
              @click="controleModalApperance"
              :disabled="isSubmitting"
            >
              {{ $t("BUTTONS.cancel") }}
            </button>
          </div>
        </div>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseModal from "../ui/BaseModal.vue";

export default {
  name: "RedeliveryConfirmationModal",

  components: {
    BaseModal,
  },

  props: {
    modalAppearanceData: {
      type: Boolean,
      required: true,
    },
    selectedItem: {
      type: Object,
      default: () => ({}),
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "",
    },
  },

  emits: ["controleModalApperance", "confirmRedelivery"],

  methods: {
    controleModalApperance() {
      this.$emit("controleModalApperance");
    },

    confirmRedelivery() {
      this.$emit("confirmRedelivery", this.selectedItem);
    },
  },
};
</script>

<style lang="scss" scoped>
.redelivery_modal_wrapper {
  .redelivery_card {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 40px 30px;

    .icon {
      width: 70px;
      height: 70px;
      background-color: #fff3cd;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      i {
        font-size: 32px;
        color: #ffc107;
      }
    }

    h2 {
      font-size: 20px;
      font-weight: 600;
      color: #333;
      margin-bottom: 10px;
    }

    .description {
      font-size: 14px;
      color: #666;
      margin-bottom: 30px;
      line-height: 1.6;
    }

    .error_message {
      display: flex;
      align-items: center;
      gap: 8px;
      background-color: #f8d7da;
      color: #721c24;
      padding: 12px 16px;
      border-radius: 6px;
      font-size: 13px;
      width: 100%;
      border: 1px solid #f5c6cb;

      i {
        font-size: 16px;
        flex-shrink: 0;
      }

      span {
        word-break: break-word;
        text-align: left;
      }
    }

    .btns_wrapper {
      display: flex;
      gap: 12px;
      width: 100%;
      justify-content: center;
      flex-wrap: wrap;

      button {
        border: none;
        padding: 10px 24px;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        min-width: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        i {
          font-size: 14px;
        }
      }

      .confirm_btn {
        background-color: #28a745;
        color: white;

        &:hover:not(:disabled) {
          background-color: #218838;
          box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
        }
      }

      .cancel_btn {
        background-color: #e9ecef;
        color: #333;

        &:hover:not(:disabled) {
          background-color: #dee2e6;
        }
      }
    }
  }
}
</style>
